function initMgBurger() {
  if (document.querySelector(".nav-mg-active") != null) {
    const navActive = document.querySelector(".nav-mg-active");
    const bugerMg = document.querySelector(".mg-navbar__burger");
    const bugerMgBurger = document.querySelector(".mg-navbar-wrapper");
    try {
      bugerMg.addEventListener("click", (event) => {
        bugerMgBurger.classList.toggle("nav-mg-active");
      });
    } catch (err) {
    }
  }
}
